import { Component, input } from '@angular/core';
import { CommonModule } from "@angular/common";
import { EvCdkTooltipComponent } from "ev-cdk-tooltip";
import { environment } from 'src/environments/environment';
import { OverlayModule } from '@angular/cdk/overlay';

@Component({
  selector: 'scoring',
  templateUrl: './scoring.component.html',
  styleUrl: './scoring.component.scss',
  imports: [EvCdkTooltipComponent, OverlayModule, CommonModule]
})
export class ScoringComponent {
  scoringValues = input.required<IScoring>();

  areaScoreTooltipVisible = false;
  areaScoreMinTooltipVisible = false;
  councilScoreTooltipVisible = false;

  getScoreCategory(score: number): string {
    if (!isNaN(score)) {
        if (score <= 3) {
            return "ikke velfungerende";
        }
        if (score <= 9) {
            return "begrenset";
        }
        if (score <= 20) {
            return "velfungerende";
        }
        
        return "-";
    }
    
    return "-";
  }

  scoreIconClass(score: number): string {
    if (score > 9) {
      return 'high-score';
    }

    return 'low-score';
  }

  openPdfGuide(): void {
    window.open(`https://${environment.resourcesStorageAccountName}.blob.core.windows.net/infopageresources/scoring/MunicipalityScore.pdf`);
  }
}

export interface IScoring {
  areaMarketScoreMin?: number;
  areaMarketScoreMax?: number;
  areaMarketScore: number;
  councilScore: number;
}
